const navigator = window.navigator;

const IE_TYPE = 'msie';
// 旧IE
const TRIDENT_TYPE = 'trident';
const EDGE_TYPE = 'edge';

/**
 * 現在のブラウザを取得
 * @returns {string}
 * @constructor
 */
const CurrentBrowser = (): string => {
    return navigator.userAgent.toLowerCase();
};

/**
 * 現在のブラウザを判定する
 * @type {{isIEBrowser: (() => boolean); isOldIEBrowser: (() => boolean); isEdgeBrowser: (() => boolean)}}
 */
export const CurrentBrowserType = {
    isIEBrowser: (): boolean => {
        return CurrentBrowser().indexOf(IE_TYPE) > -1;
    },
    isTridentBrowser: (): boolean => {
        return CurrentBrowser().indexOf(TRIDENT_TYPE) > -1;
    },
    isEdgeBrowser: (): boolean => {
        return CurrentBrowser().indexOf(EDGE_TYPE) > -1;
    },
};
